import template from './statusVerifyModal.html';
import controller from './statusVerifyModal.controller';

export const statusVerifyModalComponent = {
  name: 'statusVerifyModalComponent',
  restrict: 'E',
  bindings: {
    modalInstance: '<',
  },
  template,
  controller,
  controllerAs: 'vm',
};



// WEBPACK FOOTER //
// ./src/app/components/status/verify/components/statusVerifyModal/statusVerifyModal.component.js